import { ref } from 'vue';

/**
 * 从 localStorage 中获取当前用户名
 * @returns 响应式用户名 ref
 */
export function useUserName() {
  const userName = ref('');

  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    userName.value = userInfo?.miID ? userInfo.miID : '';
  } catch {
    console.error('Failed to parse userInfo from localStorage');
  }

  return userName;
}
